import { render, staticRenderFns } from "./outlander2022.vue?vue&type=template&id=8076e4ac&scoped=true"
import script from "./outlander2022.vue?vue&type=script&lang=js"
export * from "./outlander2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8076e4ac",
  null
  
)

export default component.exports